import { TV } from '../domain/types';

export const tvLabels: {
  [key in TV]: string
} = {
  CONDOMINIALE: 'Condominiale',
  PRIVATO: 'Privato',
  PARABOLA_SATELLITARE: 'Parabola satellitare',
};
